<!-- 废弃 -->
<template>
	<div>
		<myheader headTitle="邀请同事"></myheader>
		<div class="all_main">
			<div class="all_content_padding">
				<div class="all_tips_content_card all_text_center">
					<img :src="codeurl?('data:image/png;base64,'+codeurl):require('@/assets/images/code_default.svg')"
						style="height: 8rem;width:8rem;margin: .5rem;" />
					<!-- <div ref="sharecode" style="height: 8rem;width:8rem;margin: .5rem;" ></div> -->
					<div class="text14 margin_top_5 textcolor333">{{corpName}}</div>
					<div class="text14 margin_top_5 textcolormain">扫描二维码加入该企业</div>
				</div>
			</div>
			<div style="padding: 0 .5rem;margin-top: 5rem;">
				<button class="text14 all_button all_height_line20 bmain_active"
					@click="openCorpQrCode()">分享二维码</button>
				<button class="text14 all_button all_height_line20 margin_top_10 bmain_active"
					@click="jumpInvite()">发送短信/邮件邀请</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		saveCorpQrCode,
		openCorpQrCode
	} from '../../../utils/nativeOtherOperate.js';
	export default {
		data() {
			return {
				//企业id
				corpId: '',
				//企业名称
				corpName: '',
				//二维码base64
				codeurl: '',
			}
		},
		methods: {
			//调用系统原生打开沙盒中的图片
			openCorpQrCode() {
				if (!this.codeurl) {
					this.$Toast('未获取到企业二维码，请重试！')
					this.getQrCode()
					return
				}
				openCorpQrCode(this.corpId,this.codeurl)
				// if (this.tool) {
				// 	switch(plus.os.name){
				// 		case 'Android':
				// 		this.tool.openCorpQrCode(plus.android.runtimeMainActivity(), this.corpId)
				// 		break;
				// 		case 'iOS':
				// 		if(this.tool.initVerify()){
				// 			this.tool.openCorpQrCode(this.corpId,this.codeurl)
				// 		}
				// 		break;
				// 	}
				// }
			},
			//保存二维码到包沙盒
			saveCorpQrCode() {
				saveCorpQrCode(this.corpId, this.codeurl)
				// if (this.tool && this.codeurl) {
				// 	switch(plus.os.name){
				// 		case 'Android':
				// 		this.tool.saveCorpQrCode(plus.android.runtimeMainActivity(), this.corpId, this.codeurl)
				// 		break;
				// 		case 'iOS':
				// 		//this.tool.saveCorpQrCode(this.corpId, this.codeurl)
				// 		break;
				// 	}	
				// }
			},
			//跳转邀请同事页面
			jumpInvite() {
				this.$router.push({
					path: 'invitemember',
					query: {
						corpId: this.corpId,
						corpName: this.corpName
					}
				})
			},
			//获取二维码
			getQrCode() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/api/inviteQrCode/'+JSON.stringify({
						corpId: this.corpId
					}), {}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.codeurl = res.data
						this.saveCorpQrCode()
					}
				})
			},
			//生成二维码
			// creatQrCode() {
			// 	var qrcode = new QRCode(this.$refs.sharecode, {
			// 		text: 'corpId:' + this.corpId, // 需要转换为二维码的内容
			// 		width: 160,
			// 		height: 160,
			// 		colorDark: '#000000',
			// 		colorLight: '#ffffff',
			// 		correctLevel: QRCode.CorrectLevel.H
			// 	})
			// },
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
			},
		},
		mounted() {
			this.init()
			this.getQrCode()
		},
		beforeDestroy() {}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>